import { useTranslation } from 'react-i18next';

import { AddIcon } from '@treams/treams-icons';
import { Button } from '@treams/treams-ui';

export default function NewGoalButton(props: { userID: string }) {
	const { t } = useTranslation();

	return (
		<Button
			icon={<AddIcon />}
			title={t('goals.index.toolbar.new')}
			link={`/users/${props.userID}/goals/new`}
		/>
	);
}
